import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const CircularLoading = () => {
	return (
		<div style={{ padding: "10px 0" }}>
			<CircularProgress />
		</div>
	);
};

export default CircularLoading;
